import { IPSPaymentlanguageoptions } from "../utils/constant";
import { sendToAndroid } from "../services/androidBridge";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "../components/dropdown/Dropdown";
import { GoAlertFill } from "react-icons/go";
import { InputText } from "primereact/inputtext";
import { utilityListLanguageOptions } from "../components/dropdown/dropdown-data";

export default function IPSPayment() {
    const [selectedAccount, setSelectedAccount] = useState("");
    const [accountList, setAccountList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [merchantAccount, setMerchantAccount] = useState("");
    const [amount, setAmount] = useState("");
    const [remark, setRemark] = useState("");
    const [mercahntInfoResponse, setMercahntInfoResponse] = useState();
    const [selectedBank, setSelectedBank] = useState("");
    const [bankRequired, setBankRequired] = useState("");
    //validation states
    const [isAmountProvided, setIsAmountProvided] = useState("");
    const [isRemarkProvided, setIsRemarkProvided] = useState("");
    const [isMerchantAccountProvided, setisMerchantAccountProvided] = useState("");
    const [confirmMessage, setConfirmMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [jwt, setJwt] = useState(0);
    const [userName, setUserName] = useState("");
    const [selectedOrganization] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [closeLoading, setCloseLoading] = useState(false);
    const [warning] = useState("");
    const [onConfirm, setOnConfirm] = useState("");
    const [transferRequest, setTransferRequest] = useState("");

    const [accountRequired, setAccountRequired] = useState("");
    const [title, setTitle] = useState();

    const [isAccountOpen, setIsAccountOpen] = useState(false);
    const [isBankOpen, setIsBankOpen] = useState(false);
    const [isFirst, setIsFirst] = useState(true);
    const [bank, setBank] = useState("");

    const validateAmount = (value) => {
        const trimmedValue = value?.trim();
        const validNumberRegex = /^(?!0\d)(?:[1-9]\d*|0)(?:\.\d+)?$/;

        if (!trimmedValue) {
            return IPSPaymentlanguageoptions[jwt]?.valueError[3];
        } else if (!validNumberRegex.test(trimmedValue)) {
            return IPSPaymentlanguageoptions[jwt]?.valueError[5];
        } else if (parseFloat(trimmedValue) <= 0) {
            return IPSPaymentlanguageoptions[jwt]?.valueError[5];
        }
        return "";
    };

    const handleFirstRender = (request) => {
        if (!isFirst) {
            sendDataToAndroid(request);
        }
        setIsFirst(false);
    };

    useEffect(() => {
        if (isFirst) {
            sendDataToAndroid("first");
        }
        getDataFromAndroid();
    }, []);

    useEffect(() => {
        setTitle(utilityListLanguageOptions[jwt][1]);
    }, [jwt]);

    useEffect(() => {
        handleFirstRender("title");
    }, [title]);

    useEffect(() => {
        if (accountList.length > 0) {
            handleFirstRender("requestBankList");
        }
    }, [accountList]);

    useEffect(() => {
        sendDataToAndroid({ type: "openLoading", requestName: "openLoading" });
    }, [loading]);

    useEffect(() => {
        if (closeLoading) {
            setLoading(false);
            setCloseLoading(false);
        }
    }, [closeLoading]);

    useEffect(() => {
        if (onConfirm !== "") {
            setTransferRequest({
                fromAccount: selectedAccount,
                merchantAccount: merchantAccount,
                amount: amount,
                fromAccountHolder: userName,
                bankName: selectedBank?.value,
                merchantName: mercahntInfoResponse?.merchantName,
                hashedValue: mercahntInfoResponse?.hashedValue,
                endToEndId: mercahntInfoResponse?.endToEndId,
                remark: remark || "",
                clearing_type: mercahntInfoResponse?.clearing_type,
            });
        }
    }, [onConfirm]);

    useEffect(() => {
        if (confirmMessage !== "") handleFirstRender("confirm");
    }, [confirmMessage]);
    useEffect(() => {
        if (successMessage !== "") handleFirstRender("success");
        handleFirstRender("success");
    }, [successMessage]);

    useEffect(() => {
        if (errorMessage !== "") handleFirstRender("warning");
    }, [errorMessage]);

    useEffect(() => {
        handleFirstRender("openLoading");
    }, [loading]);

    useEffect(() => {
        handleFirstRender("openLoading");
        if (closeLoading) {
            setLoading(false);
            setCloseLoading(false);
        }
    }, [closeLoading]);

    useEffect(() => {
        handleFirstRender("warning");
    }, [warning]);

    useEffect(() => {
        if (transferRequest !== "") {
            handleFirstRender("requestTransfer");
        }
    }, [transferRequest]);

    const sendDataToAndroid = (name) => {
        var transferData = {
            transferData: [],
        };
        if (name === "return") {
            transferData = {
                transferData: [
                    {
                        type: "return",
                        request: { name: "graphData" },
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "first") {
            transferData = {
                transferData: [
                    {
                        type: "first",
                        request: { name: "first" },
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "title") {
            transferData = {
                transferData: [
                    {
                        type: "title",
                        request: { name: "title" },
                        response: { data: title },
                        name: "",
                    },
                ],
            };
        } else if (name === "openLoading") {
            transferData = {
                transferData: [
                    {
                        type: "openLoading",
                        request: { name: "openLoading" },
                        response: { data: "openLoading" },
                        name: "",
                    },
                ],
            };
        } else if (name === "closeLoading") {
            transferData = {
                transferData: [
                    {
                        type: "closeLoading",
                        request: { name: "closeLoading" },
                        response: { data: "closeLoading" },
                        name: "",
                    },
                ],
            };
        } else if (name === "warning") {
            transferData = {
                transferData: [
                    {
                        type: "warning",
                        request: { name: "warning" },
                        response: { data: errorMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "title") {
            transferData = {
                transferData: [
                    {
                        type: "title",
                        request: { name: "title" },
                        response: { data: title },
                        name: "",
                    },
                ],
            };
        } else if (name === "requestBankList") {
            transferData = {
                transferData: [
                    {
                        type: "requestPost",
                        request: { name: "BankList_v2/rest/BankList_v2" },
                        response: { data: JSON.stringify({ start: 0, end: 50 }) },
                        name: "",
                    },
                ],
            };
        } else if (name === "error") {
            transferData = {
                transferData: [
                    {
                        type: "error",
                        request: { name: "error" },
                        response: { data: errorMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "success") {
            transferData = {
                transferData: [
                    {
                        type: "success",
                        request: { name: "success" },
                        response: { data: successMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "requestTransfer") {
            transferData = {
                transferData: [
                    {
                        type: "requestPost",
                        request: { name: "IpsWithOutQr/rest/IpsPayment" },
                        response: { data: JSON.stringify(transferRequest) },
                        name: "",
                    },
                ],
            };
        } else if (name === "confirm") {
            transferData = {
                transferData: [
                    {
                        type: "confirm",
                        request: { name: "confirm" },
                        response: { data: confirmMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "requestInfo") {
            transferData = {
                transferData: [
                    {
                        type: "requestPost",
                        request: { name: "IpsWithOutQr/rest/merchantInfo" },
                        response: {
                            data: JSON.stringify({
                                merchantAccount: merchantAccount,
                                bankName: selectedBank.value,
                            }),
                        },
                        name: "",
                    },
                ],
            };
        }
        setConfirmMessage("");
        setSuccessMessage("");
        setTransferRequest("");
        setErrorMessage("");
        setOnConfirm("");
        console.log("Sending data to Android:", JSON.stringify(transferData));
        sendToAndroid(transferData);
    };

    const getAccountListFromAndroid = (obj, objData) => {
        if (obj.response !== undefined && objData !== undefined) {
            let uniqueAccountList = [];
            JSON.parse(objData).forEach((account) => {
                uniqueAccountList = [
                    ...uniqueAccountList,
                    { label: account.accounts, value: account.accounts },
                ];
                setAccountList([...uniqueAccountList]);
            });
        }
    };

    const getDataFromAndroid = () => {
        window.receiveDataFromAndroid = (data) => {
            const dataString = JSON.stringify(data);
            const obj = JSON.parse(dataString);
            const objName = JSON.parse(obj.request).name;
            const objData = JSON.parse(obj.response).data;
            const urlFromResponse = JSON.parse(obj.request).url;

            switch (objName) {
                case "accountList":
                    getAccountListFromAndroid(obj, objData);
                    break;
                case "confirmResponse":
                    setOnConfirm("true");
                    break;
                case "jwt":
                    setJwt(objData);
                    break;
                case "response":
                    handleDataBasedOnUrl(urlFromResponse, objData);
                    break;
                case "userName":
                    setUserName(objData);
                    break;
                default:
                    break;
            }
        };
    };

    const handleDataBasedOnUrl = (url, responseData) => {
        if (url.includes("BankList_v2/rest/BankList_v2")) {
            const parsedResponse = JSON.parse(responseData);
            if (parsedResponse?.status) {
                const transformedBankList = parsedResponse.institute
                    .filter((bank) => bank.swiftCode && bank.swiftCode.trim() !== "NA")
                    .map((bank) => ({
                        label: bank.name,
                        value: bank.swiftCode,
                        key: bank.instid,
                    }));
                setBankList(transformedBankList);
                setErrorMessage("");
            } else {
                setErrorMessage(
                    parsedResponse.desc || "An error occurred while fetching bank list."
                );
                setSuccessMessage("");
            }
        } else if (url.includes("IpsWithOutQr/rest/merchantInfo")) {
            const parsedResponse = JSON.parse(responseData);
            if (parsedResponse?.status) {
                setMercahntInfoResponse(parsedResponse);
                setErrorMessage("");
            } else {
                setErrorMessage(
                    parsedResponse.description ||
                    "An error occurred while fetching merchant information."
                );
                setSuccessMessage("");
            }
        } else if (url.includes("IpsWithOutQr/rest/IpsPayment")) {
            const parsedResponse = JSON.parse(responseData);
            if (parsedResponse?.status) {
                console.log(selectedBank)
                const message = `Dear Customer ETB ${parsedResponse.amount} has been debited from ${parsedResponse.fromAccountHolder} and transferred to ${bank.label || ""} , Account holder ${parsedResponse.toAccountHolder} , to Account number ${parsedResponse.toAccount} reason ${parsedResponse.remark} done via mobile on ${parsedResponse.date} with transaction ID ${parsedResponse.refNo}.`;
                setSuccessMessage(message);
                setErrorMessage("");
            } else {
                setErrorMessage(
                    parsedResponse.statusDesc ||
                    "An error occurred while processing the payment."
                );
                setSuccessMessage("");
            }
        }
    };

    const handleTransfer = () => {
        const amountError = validateAmount(amount);

        if (!selectedBank || !merchantAccount || !amount || !remark) {
            setAccountRequired(!selectedAccount && "Please select an account");
            setIsAmountProvided(
                amountError || (!amount && "Please enter the amount")
            );
            setisMerchantAccountProvided(
                !merchantAccount && "Please enter merchant account"
            );
            setBankRequired(!selectedBank && "Please select bank");
            setIsRemarkProvided(!remark && "Please enter a remark");
            return;
        }

        handleFirstRender("requestInfo");
    };

    useEffect(() => {
        if (mercahntInfoResponse?.status) {
            const message = `
        <br>From fAccount: </br>${selectedAccount}<br>
        <br>Beneficiary Account: </br>${merchantAccount}<br>
        <br>Beneficiary Name:</br> ${mercahntInfoResponse.merchantName} <br>
        <br>Amount:</br> ${amount} <br>
        <br>Payment Reason:</br> ${remark} <br>
      `;
            setConfirmMessage(message);
        }
    }, [mercahntInfoResponse]);

    const handleIsAccountOpen = () => {
        setIsAccountOpen(!isAccountOpen);
    };

    const handleAccountSelection = (option) => {
        setSelectedAccount(option);
        handleIsAccountOpen();
    };

    const handleIsBankOpen = () => {
        setIsBankOpen(!isBankOpen);
    };
    const handleBankSelection = (option) => {
        setSelectedBank(option);
        setBank(option);
        handleIsBankOpen();
    };

    const handleMerchantAccountChange = (e) => {
        setMerchantAccount(e.target.value);
        setisMerchantAccountProvided("");
    };
    const handleAmountChange = (e) => {
        const value = e.target.value.trim();
        setAmount(value);

        const validationError = validateAmount(value);
        setIsAmountProvided(validationError);
    };

    const handleReasonChange = (e) => {
        setRemark(e.target.value);
        setIsRemarkProvided("");
    };

    return (
        // <ComingSoon/>
        <div className="service-screen w-full max-w-md mx-auto p-4">
            <div className="mb-4 font-light">
                <label className="block text-gray-700 mb-2 text-lg font-semibold">
                    {IPSPaymentlanguageoptions[jwt]?.labels[0]}
                </label>
                <div>
                    <Dropdown
                        options={accountList}
                        id={"account"}
                        placeholder={IPSPaymentlanguageoptions[jwt]?.placeholder[0]}
                        isOpen={isAccountOpen}
                        selectedAccount={selectedAccount}
                        selectedOrganization={selectedOrganization}
                        handleSelection={handleAccountSelection}
                        handleDropDown={handleIsAccountOpen}
                        setAccountRequired={setAccountRequired}
                    />
                    {accountRequired && (
                        <p className="warnings">
                            <GoAlertFill />
                            {IPSPaymentlanguageoptions[jwt]?.valueError[0]}
                        </p>
                    )}
                </div>
                <div>
                    <label className="block text-gray-700 mb-2 text-lg font-semibold">
                        {IPSPaymentlanguageoptions[jwt]?.labels[1]}
                    </label>
                    <Dropdown
                        options={bankList}
                        id={"bankList"}
                        placeholder={IPSPaymentlanguageoptions[jwt]?.placeholder[1]}
                        label={IPSPaymentlanguageoptions[jwt]?.labels[1]}
                        isOpen={isBankOpen}
                        selectedAccount={selectedAccount}
                        selectedOrganization={selectedBank}
                        handleSelection={handleBankSelection}
                        handleDropDown={handleIsBankOpen}
                        setAccountRequired={setAccountRequired}
                        setOrganizationRequired={setBankRequired}
                    />
                    {bankRequired && (
                        <p className="warnings">
                            <GoAlertFill />
                            {IPSPaymentlanguageoptions[jwt]?.valueError[1]}
                        </p>
                    )}
                </div>
                <div>
                    <label className="block text-gray-700 mb-2 text-lg font-semibold">
                        {IPSPaymentlanguageoptions[jwt]?.labels[2]}
                    </label>
                    <InputText
                        id="merchantAccount"
                        placeholder={IPSPaymentlanguageoptions[jwt]?.placeholder[2]}
                        type="text"
                        value={merchantAccount}
                        onChange={handleMerchantAccountChange}
                        style={{ resize: "none" }}
                        className="w-full outline-none border-2 border-slate-600 text-lg p-4 rounded-xl bg-[#f5f5f5]"
                    />
                    {isMerchantAccountProvided && (
                        <p className="amountwarning warnings">
                            <GoAlertFill />
                            {IPSPaymentlanguageoptions[jwt]?.valueError[2]}
                        </p>
                    )}
                </div>
                <div>
                    <label className="block text-gray-700 mb-2 text-lg font-semibold">
                        {IPSPaymentlanguageoptions[jwt]?.labels[3]}
                    </label>
                    <InputText
                        id="amount"
                        placeholder={IPSPaymentlanguageoptions[jwt]?.placeholder[3]}
                        type="number"
                        inputMode="decimal"
                        min="0.01"
                        step="0.01"
                        value={amount}
                        onChange={handleAmountChange}
                        style={{ resize: "none" }}
                        className={`w-full outline-none border-2 text-lg p-4 rounded-xl bg-[#f5f5f5] ${
                            isAmountProvided ? "border-red-500" : "border-slate-600"
                        }`}
                    />
                    {isAmountProvided && (
                        <p className="amountwarning warnings flex items-center gap-1 text-red-600 mt-1">
                            <GoAlertFill />
                            {isAmountProvided}
                        </p>
                    )}
                </div>

                <div>
                    <label className="block text-gray-700 mb-2 text-lg font-semibold">
                        {IPSPaymentlanguageoptions[jwt]?.labels[8]}
                    </label>
                    <InputText
                        id="remark"
                        placeholder={IPSPaymentlanguageoptions[jwt]?.placeholder[5]}
                        type="text"
                        value={remark}
                        onChange={handleReasonChange}
                        style={{ resize: "none" }}
                        className="w-full outline-none border-2 border-slate-600 text-lg p-4 rounded-xl bg-[#f5f5f5]"
                    />
                    {isRemarkProvided && (
                        <p className="amountwarning warnings">
                            <GoAlertFill />
                            {IPSPaymentlanguageoptions[jwt]?.valueError[4]}
                        </p>
                    )}
                </div>
                <div className="flex justify-center items-center">
                    <Button
                        label={IPSPaymentlanguageoptions[jwt]?.button}
                        severity="info"
                        icon="pi pi-arrow-right"
                        onClick={handleTransfer}
                        size="small"
                        className="mt-4 text-[12px] p-button-success p-5 pl-12 pr-12 bg-[#0351b3] text-[#ffffff] hover:bg-blue-800 rounded-xl font-semibold"
                    />
                </div>
            </div>
        </div>
    );
}

